import {
  Box,
  ComponentMultiStyleConfig,
  Divider,
  useMultiStyleConfig,
  VStack,
} from "@chakra-ui/react";
import React from "react";
import { ComponentStyleProps } from "../../../../../lib/styles/props/component-style-props";
import { CMFormCommentText } from "../../text";
import { hasValue } from "../../../../../lib/util/common-util";

/**
 * commentsListに格納されるオブジェクトの型定義
 */
export type Comments = {
  mainComment?: {
    userName?: string;
    date: Date;
    comment: string;
  };
  replyComment?: {
    userName?: string;
    date?: Date;
    comment?: string;
  };
  isHistory?: boolean;
  path?: string;
};

export type FormCommentBalloonProps = {
  /**
   * 修正依頼コメント・返信履歴のprops（履歴参照画面用）
   */
  commentsList: Comments[];
} & ComponentStyleProps;

export const FormCommentBalloon = ({
  commentsList,
  sx,
  ...rest
}: FormCommentBalloonProps) => {
  const styles = useMultiStyleConfig("FormCommentBalloonStyles");

  return (
    <VStack
      sx={{ ...styles.container, ...sx }}
      {...rest}
      divider={<Divider borderColor="orange.500" />}
    >
      {(commentsList ?? []).map((comments, index) => (
        <Box key={index}>
          {/* isHistory
            trueの場合、インデントを追加 */}
          <Box pl={comments.isHistory ? "32px" : "0px"}>
            <CMFormCommentText
              userName={comments.mainComment?.userName}
              date={comments.mainComment?.date}
              comment={comments.mainComment?.comment}
              editable={false}
              sx={{ ...styles.mainComment, ...sx }}
              {...rest}
            />
          </Box>
          {hasValue(comments.replyComment) && (
            <Box pl={comments.isHistory ? "32px" : "0px"}>
              <CMFormCommentText
                userName={comments.replyComment?.userName}
                date={comments.replyComment?.date}
                comment={comments.replyComment?.comment}
                editable={false}
                sx={{ ...styles.replyComment, ...sx }}
                {...rest}
              />
            </Box>
          )}
        </Box>
      ))}
    </VStack>
  );
};

export const FormCommentBalloonStyles: ComponentMultiStyleConfig = {
  parts: ["container", "mainComment", "replyComment", "border"],
  baseStyle: {
    container: {
      maxW: "400px",
      maxH: "500px",
      overflow: "auto",

      pt: "2",
      pr: "3",
      pb: "3",
      pl: "3",

      zIndex: 10,
      alignItems: "stretch",
      bgColor: "orange.100",

      borderWidth: "1px",
      borderColor: "orange.500",
      borderRadius: "md",
      boxShadow: "md",
    },
    mainComment: {},
    replyComment: {
      pt: "10px",
      pl: "16px",
    },
  },
};
